import { render, staticRenderFns } from "./SuggestedCartMenuBlock.vue?vue&type=template&id=4b6e9eb4&scoped=true"
import script from "./SuggestedCartMenuBlock.vue?vue&type=script&lang=js"
export * from "./SuggestedCartMenuBlock.vue?vue&type=script&lang=js"
import style0 from "./SuggestedCartMenuBlock.vue?vue&type=style&index=0&id=4b6e9eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6e9eb4",
  null
  
)

export default component.exports